
import Banner from "../components/Banner";
import Bgcolor from "../components/Bgcolor";
import Contact from "../components/Contact";
import ListExperience from "../components/HistoryExperience";
import ListSkills from "../components/ListSkills";
import AboutMe from "../components/AboutMe";
import Service from "../components/Service";


const Home = () => {
  return (
    <div
    className=""
    >
      <div className="bg-[#c5c7c9] min-h-screen mx-auto">
        <div className="bg-[#ffffff] min-h-screen p-20 w-full mx-auto">        
          <div>
            <Bgcolor></Bgcolor>
          </div>

          <div id="banner" className="flex items-start justify-center mt-5 py-32 w-full">
                <Banner></Banner>
          </div>
          <div id="service" className="flex items-start justify-center mt-5 py-32 ">
                <Service></Service>
          </div>
          <div id="experience" className="flex items-start justify-center mt-5 py-32 w-full">           
            <ListExperience></ListExperience>
          </div>
          <div id="skills" className="flex items-start justify-center mt-5 py-32  w-full">
            <ListSkills></ListSkills>
          </div>
          <div id="contact" className="flex items-start justify-center mt-5 py-32  w-full">
            <Contact></Contact>
          </div>
          <div id="location" className="flex items-start justify-center mt-5 py-32  w-full">
            <AboutMe></AboutMe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
